export const FETCH_WAREHSSUBSCRPTN_INIT_ACTION = "FETCH_WAREHSSUBSCRPTN_INIT_ACTION";
export const FETCH_WAREHSSUBSCRPTN_SUCCESS_ACTION = FETCH_WAREHSSUBSCRPTN_INIT_ACTION + "_SUCCESS";
export const FETCH_WAREHSSUBSCRPTN_FAIL_ACTION = FETCH_WAREHSSUBSCRPTN_INIT_ACTION + "_ERROR";

export const FETCH_WAREHSPLAN_INIT_ACTION = 'FETCH_WAREHSPLAN_INIT_ACTION'
export const FETCH_WAREHSPLAN_SUCCESS_ACTION = FETCH_WAREHSPLAN_INIT_ACTION + "_SUCCESS";
export const FETCH_WAREHSPLAN_FAIL_ACTION = FETCH_WAREHSPLAN_INIT_ACTION + "_ERROR";

export const CLEAR_WAREHSSUBSCRPTN_INIT_ACTION = "CLEAR_WAREHSSUBSCRPTN_INIT_ACTION";
